/**
 * Pauses a Splide AutoScroll instance while the slider is out of the viewport
 * and resumes it when it comes back. Saves the per-frame work the auto-scroll
 * loop otherwise does for a slider nobody can see.
 */
const pauseAutoScrollOffscreen = (splide) => {
    if (typeof IntersectionObserver === "undefined") {
        return;
    }

    const autoScroll = splide.Components.AutoScroll;
    if (!autoScroll) {
        return;
    }

    let visible = true;

    const sync = () => {
        if (visible) {
            autoScroll.play();
        } else {
            // false = temporary pause, so play() can resume it.
            autoScroll.pause(false);
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                visible = entry.isIntersecting;
            });
            sync();
        },
        { rootMargin: "100px 0px" }
    );

    observer.observe(splide.root);

    // AutoScroll starts itself on window "load"; re-apply our state after that.
    if (document.readyState !== "complete") {
        window.addEventListener("load", sync, { once: true });
    }

    splide.on("destroy", () => {
        observer.disconnect();
        window.removeEventListener("load", sync);
    });
};

export default pauseAutoScrollOffscreen;
